module.exports = __webpack_public_path__ + "static/img/til4.ebf6d2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/til4.png
// module id = O4+4
// module chunks = 0